import { Typography } from '@mui/material';

import ChartBoxMultipleOutline from '@/assets/icons/ChartBoxMultipleOutline';
import { Permission } from '@/entities/permissions';
import AccordionSection from '@/features/DataHub/components/AccordionSection';
import BasicUserPreview from '@/features/DataHub/components/Preview/BasicUserPreview';
import usePermission from '@/shared/hooks/usePermission';

import Preview from '../Preview';

const PreviewAccordion = () => {
  const { hasPermission } = usePermission();

  return (
    <AccordionSection
      icon={<ChartBoxMultipleOutline />}
      title='Chart view'
    >
      <Typography
        sx={{
          fontSize: '12px',
          color: 'text.disabled',
          mb: '16px'
        }}
      >
        Chart displays up to 6 items
      </Typography>
      {hasPermission(Permission.ExportDataChartPreview) ? (
        <Preview showLegend />
      ) : (
        <BasicUserPreview />
      )}
    </AccordionSection>
  );
};

export default PreviewAccordion;
